module.exports = __webpack_public_path__ + "img/Rotation5.dae6fa98.jpg";